<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">
              <strong>{{ user.real_name }}</strong>割引プランの登録
            </h3>
          </CCardHeader>
          <CCardBody class="px-5">
            <details>
              <summary>割引プランの登録に関する説明(クリックで表示)</summary>
              <ul>
                <li>割引プランは会員に適用する割引情報であり、オペレーターが会員に付与します</li>
                <li>会員システムへのクーポン掲載対象外です</li>
                <li>金額割引については、SKUを精算対象として利用できます</li>
                <li>割引プランに利用回数制限はありません</li>
              </ul>
            </details>
            <CForm class="member-info modal-form">
              <CRow>
                <CCol lg="6">
                  <CInput
                    label="SKU"
                    horizontal
                    v-model="couponToEdit.sku"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <CInput
                    label="割引プラン名"
                    horizontal
                    v-model="couponToEdit.name"
                    class="required-mark"
                    required
                  />
                  <div
                    class="text-danger input-info"
                    v-if="!$v.couponToEdit.name.required"
                  >
                    割引プラン名は必須です
                  </div>
                </CCol>
                <CCol lg="6">
                  <CTextarea
                    rows="1"
                    label="割引プラン説明"
                    horizontal
                    v-model="couponToEdit.description"
                    class="required-mark"
                    required
                  />
                  <div
                    class="text-danger input-info"
                    v-if="!$v.couponToEdit.description.required"
                  >
                    割引プラン説明は必須です
                  </div>
                </CCol>
              </CRow>
              <!-- CRow>
                <CCol lg="6">
                  <CInput
                    label="掲載開始日"
                    type="date"
                    min="1900-01-01"
                    max="2100-12-31"
                    horizontal
                    v-model="couponToEdit.activatedSince"
                    class="required-mark"
                    required
                  />
                  <div class="text-danger input-info" v-if="!$v.couponToEdit.activatedSince.required">
                    掲載開始日は必須です
                  </div>
                </CCol>
                <CCol lg="6">
                  <CInput
                    label="掲載終了日"
                    type="date"
                    min="1900-01-01"
                    max="2100-12-31"
                    horizontal
                    v-model="couponToEdit.activatedBefore"
                    class="required-mark"
                    required
                  />
                  <div class="text-danger input-info" v-if="!$v.couponToEdit.activatedBefore.required">
                    掲載終了日は必須です
                  </div>
                  <div 
                    class="text-danger input-info" 
                    v-if="!compareDate(couponToEdit.activatedSince, couponToEdit.activatedBefore)">
                    「掲載開始日≦掲載終了日」となる日付を指定してください
                  </div>
                </CCol>
              </CRow-->

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="利用開始日"
                    type="date"
                    min="1900-01-01"
                    max="2100-12-31"
                    horizontal
                    v-model="couponToEdit.validateSince"
                    class="required-mark"
                    required
                  />
                  <div
                    class="text-danger input-info"
                    v-if="!$v.couponToEdit.validateSince.required"
                  >
                    利用開始日は必須です
                  </div>
                </CCol>
                <CCol lg="6">
                  <CInput
                    label="利用終了日"
                    type="date"
                    min="1900-01-01"
                    max="2100-12-31"
                    horizontal
                    v-model="couponToEdit.validateUntil"
                    class="required-mark"
                    required
                  />
                  <div
                    class="text-danger input-info"
                    v-if="!$v.couponToEdit.validateUntil.required"
                  >
                    利用終了日は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!compareDate(couponToEdit.validateSince, couponToEdit.validateUntil)"
                  >
                    「利用開始日≦利用終了日」となる日付を指定してください
                  </div>
                  <!--div 
                    class="text-danger input-info" 
                    v-if="!compareDate(couponToEdit.activatedBefore, couponToEdit.validateUntil)">
                    「掲載終了日≦利用終了日」となる日付を指定してください
                  </div-->
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="クーポン画像"
                    description="※「10/31バナー  /banner/coupon_banner_1031.jpg 」	「11/1バナー  /banner/coupon_banner_1101.jpg 」"
                    horizontal
                    v-model="couponToEdit.picture"
                  />
                </CCol>

                <!-- CCol lg="6" class="checkbok_d">
                  <div class="form-group form-row">
                    <label class="col-form-label col-sm-3">複数獲得可否</label>
                    <div class="col-sm-9 pl-0">
                      <CInputCheckbox
                        horizontal
                        :checked.sync="couponToEdit.multiple"
                        description="1人の会員が本クーポンを複数回獲得可能とする場合、チェックしてください"
                      />
                    </div>
                  </div>
                </CCol-->
              </CRow>
              <!-- coupon option ↓↓↓ -->
              <!-- <CRow>
                <CCol class="px-2 py-0">
                  <h4 class="sub-title m-0">Coupon Options</h4>
                </CCol>
              </CRow> -->
              <!-- {{couponToEdit}} -->
              <CRow
                class="coupon-opion mx-5 my-4 px-3 pb-3 bg-soft card"
                v-for="(option, index) in couponToEdit.options"
                :key="index"
              >
                <CCol>
                  <CRow>
                    <CCol>
                      <h4 class="sub-title">オプション: {{ index+1 }}</h4>
                    </CCol>
                    <CCol v-if="index > 0">
                      <!-- TODO: 右寄せにする -->
                      <CButton
                        color="dark"
                        @click="deleteOption(index)"
                      >
                        <i class="icon cil-minus"></i> オプション削除
                      </CButton>
                    </CCol>
                  </CRow>

                  <CRow>
                    <CCol lg="6">
                      <CInput
                        label="SKU"
                        horizontal
                        v-model="option.sku"
                      />
                    </CCol>
                  </CRow>

                  <CRow>
                    <CCol lg="6">
                      <CInput
                        label="オプション名"
                        horizontal
                        v-model="option.name"
                        class="required-mark"
                        required
                      />
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].name.required"
                      >
                        オプション名は必須です
                      </div>
                    </CCol>

                    <CCol lg="6">
                      <CTextarea
                        label="オプション説明"
                        type="textare"
                        horizontal
                        rows="1"
                        v-model="option.description"
                        class="required-mark"
                        required
                      />
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].description.required"
                      >
                        オプション説明は必須です
                      </div>
                    </CCol>
                  </CRow>

                  <CRow>
                    <CCol lg="6">
                      <CInput
                        label="割引比率"
                        type="number"
                        horizontal
                        v-model="option.value"
                        class="required-mark"
                        required
                        number
                      />
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].value.required"
                      >
                        割引比率は必須です
                      </div>
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].value.minValue"
                      >
                        割引比率は最小値{{RATE_MIN_VALUE}}
                      </div>
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].value.maxValue"
                      >
                        割引比率は最大値{{RATE_MAX_VALUE}}
                      </div>
                    </CCol>

                    <CCol lg="6">
                      <CInput
                        label="最低利用金額"
                        type="number"
                        horizontal
                        v-model="option.minPrice"
                        class="required-mark"
                        required
                        number
                      />
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].minPrice.required"
                      >
                        最低利用金額は必須です
                      </div>
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].minPrice.minValue"
                      >
                        最低利用金額は最小値{{MIN_PRICE_MIN_VALUE}}
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol lg="6">
                      <CInput
                        label="全在庫数"
                        horizontal
                        v-model="option.activations"
                        class="required-mark"
                        required
                        number
                      />
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].activations.required"
                      >
                        全在庫数は必須です
                      </div>
                      <div
                        class="text-danger input-info"
                        v-if="!$v.couponToEdit.options.$each[index].activations.minValue"
                      >
                        全在庫数は最小値{{ACTIVATIONS_MIN_VALUE}}
                      </div>
                    </CCol>

                    <!-- <CCol lg="6">
                      <CInput
                        label="獲得数"
                        horizontal
                        v-model="option.activated"
                      />
                    </CCol> -->
                  </CRow>
                </CCol>
              </CRow>
              <CRow>
                <CCol
                  lg="6"
                  class="px-5"
                >
                  <CButton
                    color="dark"
                    @click="addNewOption()"
                  ><i class="icon cil-plus"></i> オプション追加</CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
          <CCardFooter class="px-5">
            <CButton
              @click="saveCoupon()"
              color="success"
              class="px-4"
              :disabled="$v.couponToEdit.$invalid"
            >
              <i class="icon cil-save"></i> 登録
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      :show.sync="ConfirmModal"
      :closeOnBackdrop="false"
      :centered="true"
      size="m"
      color="success"
    >
      <!-- パスワード更新 -->
      <div class="modal-body px-2">
        <p>クーポンが正常に作成されました。</p>
      </div>
      <template #header>
        <h6 class="modal-title">クーポンが正常に作成されました。</h6>
      </template>
      <template #footer>
        <CButton
          @click="
            ConfirmModal = false;
            resetData();
          "
          color="danger"
        >閉じる</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="ErrorModal"
      :centered="true"
      size="m"
      color="danger"
    >
      <!-- パスワード更新 -->
      <div class="modal-body px-2">
        <p>{{ errors }}</p>
      </div>
      <template #header>
        <h6 class="modal-title">Error</h6>
      </template>
      <template #footer>
        <CButton
          @click="ErrorModal = false"
          color="danger"
        >閉じる</CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {
  required,
  minValue,
  maxValue
} from "vuelidate/lib/validators";

export const RATE_MIN_VALUE = 1
export const RATE_MAX_VALUE = 100
export const MIN_PRICE_MIN_VALUE = 0
export const ACTIVATIONS_MIN_VALUE = 1

export default {

  name: "Discount",
  data() {
    return {

      MIN_PRICE_MIN_VALUE,
      RATE_MIN_VALUE,
      RATE_MAX_VALUE,
      ACTIVATIONS_MIN_VALUE,
      user: {},
      ConfirmModal: false,
      ErrorModal: false,
      // type: "2",
      radioOption: [
        {
          label: "割引金額",
          value: 2,
        },
        {
          label: "割引率",
          value: 1,
        },
      ],
      couponToEdit: {
        sku: "",
        name: "",
        description: "",
        activatedSince: "",
        activatedBefore: "",
        validateSince: "",
        validateUntil: "",
        multiple: false,
        enabled: true,

        options: [
          {
            sku: "",
            name: "",
            value: 0,
            description: "",
            typeOption: "2",
            type: 1,
            count: 1,
            minPrice: 0,
            activations: 100,
            activated: 0,
            order: 0,
          },
        ],
      },
    };
  },
  validations: {
    couponToEdit: {
      sku: {},
      name: { required },
      description: { required },
      validateSince: { required },
      validateUntil: { required },
      multiple: {},
      picture: {},
      // enabled: { },
      options: {
        required,
        $each: {
          name: { required },
          description: { required },
          activations: { required, minValue: minValue(ACTIVATIONS_MIN_VALUE) },
          minPrice: { required, minValue: minValue(MIN_PRICE_MIN_VALUE) },
          value: { required, minValue: minValue(RATE_MIN_VALUE), maxValue: maxValue(RATE_MAX_VALUE) },
        },
        // sku: {},
        // name: { required },
        // typeOption: { required },
        // type: { required },
        // value: { required, minValue: minValue(0) },
        // description: { required },
        // count: { required, minValue: minValue(1) },
        // minPrice: { required, minValue: minValue(0) },
        // activations: { required, minValue: minValue(0) },
        // activated: {},
      },
    },
  },

  methods: {
    addNewOption() {
      let newObject = {
        sku: "",
        name: "",
        value: 0,
        description: "",
        type: 1,
        count: 1,
        minPrice: 0,
        activations: 100,
        activated: 0,
      };
      this.couponToEdit.options.push(newObject);
    },

    deleteOption(index) {
      this.couponToEdit.options.splice(index, 1);
    },

    saveCoupon: function () {
      var urlRequest;
      urlRequest = "/rest/coupon/discount";

      // オプションの表示順を採番
      this.couponToEdit.options.forEach((a, index) => a.order = index + 1)

      axios
        .post(urlRequest, this.couponToEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.ConfirmModal = true;
          // Object.assign(this.$data, this.$options.data());
        })
        .catch((err) => {

          console.log("Updating profile error: " + err);
          this.errors = err;
          this.ErrorModal = true;
          // Object.assign(this.$data, this.$options.data());
          // alert("error" + err);
        });
    },

    resetData() {
      Object.assign(this.$data, this.$options.data.call(this));
    },

    compareDate(since, from) {
      return since <= from;
    },

  },

  beforeMount() { },
};
</script>
